// extracted by mini-css-extract-plugin
module.exports = {"form_wrapper":"contact_form_wrapper__gfilj","form_title":"contact_form_title__Bvlsq"};